<template>
  <div class="brand">
    <tree-transfer
      v-loading="loadClassify"
      :title="transTitle"
      :from_data='fromData'
      :to_data='toData'
      @addBtn='add'
      pid='c_parent'
      @removeBtn='remove'
      :mode='mode'
      height='540px'
      filter
    ></tree-transfer>
    <el-button
      type="primary"
      @click="saveClassify"
    >保存</el-button>
  </div>
</template>
<script>
import treeTransfer from 'el-tree-transfer'
import { getMallClassifyList, getMyClassifyList, saveMyClassifyList } from '@/models/classifyModel'
import { parseJson, clearNullList, deepCopy } from '@/utils/utils'
export default {
  name: 'classify',
  components: { treeTransfer },
  data () {
    return {
      transTitle: ['商城分类', '我的分类'],
      mode: 'transfer', // transfer addressList
      fromData: [],
      toData: [],
      loadClassify: true,
      toDataIds: '',
      firstFromData: [],
      firstToData: []
    }
  },
  mounted () {
    this.getClassifyList()
  },
  methods: {
    // 获取数据
    async getClassifyList () {
      this.loadClassify = true
      await this.getMallClassifyList()
      await this.getMyClassifyList()
      this.loadClassify = false
    },
    // 获取左侧列表
    async getMallClassifyList () {
      let data = await getMallClassifyList()
      let changeForm = { c_name: 'label', c_parent: 'pid', id: 'oid', c_index_pic_web: 'image', path: 'cate_path' }
      for (let i in changeForm) {
        data = parseJson(data, i, changeForm[i])
      }
      this.firstFromData = data
    },
    // 获取右侧列表id
    async getMyClassifyList () {
      let data = await getMyClassifyList()
      let toDataList
      if (data.length !== 0) {
        toDataList = data[0].oid.split(',')
      }
      let newFromData = deepCopy(this.firstFromData)
      if (toDataList) {
        let newToData = deepCopy(this.firstFromData)
        this.getNewMallClassifyList(newFromData, toDataList)
        this.getNewMyClassifyList(newToData, toDataList) // 过滤第三级
        this.getNewMyClassifyList(newToData, toDataList) // 过滤第二级
        this.getNewMyClassifyList(newToData, toDataList) // 过滤第一级
        clearNullList(newFromData, newToData)
        clearNullList(newFromData, newToData)
        this.toData = newToData
        this.toDataIds = ''
        this.getToDataIds(this.toData)
      }
      this.fromData = newFromData
    },
    // 过滤左侧列表
    getNewMallClassifyList (fromData, toDataList) {
      for (let j = 0; j < fromData.length; j++) {
        if (fromData[j].children && fromData[j].children.length !== 0) {
          this.getNewMallClassifyList(fromData[j].children, toDataList)
        } else if ((fromData[j].children && fromData[j].children.length === 0) || !fromData[j].children) {
          let data = toDataList.filter(item => { return item !== fromData[j].id })
          if (data.length !== toDataList.length) {
            fromData.splice(j, 1)
            j--
          }
        }
      }
    },
    // 获取右侧列表
    getNewMyClassifyList (fromData, toDataList) {
      for (let j = 0; j < fromData.length; j++) {
        if (fromData[j].children && fromData[j].children.length !== 0) {
          this.getNewMyClassifyList(fromData[j].children, toDataList)
        } else if ((fromData[j].children && fromData[j].children.length === 0) || !fromData[j].children) {
          let data = toDataList.filter(item => { return item !== fromData[j].id })
          if (data.length === toDataList.length) {
            fromData.splice(j, 1)
            j--
          }
        }
      }
    },
    async saveClassify () {
      let params = {
        oid: this.toDataIds
      }
      await saveMyClassifyList(params)
      await this.getClassifyList()
    },
    getToDataIds (toData) {
      for (let i of toData) {
        if (i.children && i.children.length !== 0) {
          this.getToDataIds(i.children)
        } else {
          if (this.toDataIds === '') {
            this.toDataIds = i.id
          } else {
            this.toDataIds = this.toDataIds + ',' + i.id
          }
        }
      }
    },
    // 监听穿梭框组件添加
    add (fromData, toData, obj) {
      this.toDataIds = ''
      this.getToDataIds(toData)
    },
    // 监听穿梭框组件移除
    remove (fromData, toData, obj) {
      this.toDataIds = ''
      this.getToDataIds(toData)
    }
  }
}
</script>
<style lang="scss" scoped>
.brand {
  padding: 10px;
  .el-button {
    width: 100px;
    height: 35px;
    margin: 70px 220px;
    line-height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/classify.vue